import { Card, Text, Title, Wrapper } from './highlightCardSkeleton.styles';
import { HighlightCardSkeletonProps } from './highlightCardSkeleton.types';

const HighlightCardSkeleton = ({ length = 1 }: HighlightCardSkeletonProps) => {
  return (
    <Wrapper role="status" aria-busy="true">
      {Array.from({ length }, (_, index) => (
        <Card
          key={index}
          className="_p-3 _rounded-lg _border _border-gray-300"
          data-test="highlight-card"
        >
          <Title className="_rounded-pill _mb-2" />
          <Text className="_rounded-pill" />
        </Card>
      ))}
    </Wrapper>
  );
};

export default HighlightCardSkeleton;
